(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mcw-ab"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('click', event => {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (typeof window.plausible !== 'function') return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let destination;
    try { destination = new URL(link.href, location.origin); } catch { return; }
    if (link.closest('.mcw-crosssell, .cart-xsell') && destination.origin === location.origin) {
      window.plausible('CrossSellClick', { props: { source: location.pathname, destination: destination.pathname } });
    }
    if (link.matches('.mcw-guide-cta-link') && destination.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections)\//i.test(destination.pathname)) {
      window.plausible('GuideToShopClick', { props: { source: location.pathname, destination: destination.pathname } });
    }
    if (/(^|\.)amazon\.[a-z.]+$/.test(destination.hostname)) {
      const spot = link.closest('.mcwbb') ? 'buy-box' : link.closest('.bkh') ? 'books-hub' : 'content';
      window.plausible('AmazonClick', { props: { marketplace: destination.hostname.replace(/^www\./, ''), page: location.pathname, spot } });
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mcw-sale-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.mcwSaleCountdown) return;
    window.mcwSaleCountdown = true;
    const pad = (n) => (n < 10 ? '0' : '') + n;
    const tick = () => {
      const now = Date.now();
      document.querySelectorAll('.mcw-sale-cd[data-end]').forEach((el) => {
        // BLACK CROCHET WEEKS 2026: data-end may also be epoch seconds (built from Theme settings > bcw_end)
        const raw = el.getAttribute('data-end');
        const end = /^\d+$/.test(raw) ? Number(raw) * 1000 : Date.parse(raw);
        const left = end - now;
        if (Number.isNaN(end) || left <= 0 || left > 7 * 86400000) { el.hidden = true; return; }
        const s = Math.floor(left / 1000);
        const d = Math.floor(s / 86400);
        const h = Math.floor((s % 86400) / 3600);
        const m = Math.floor((s % 3600) / 60);
        // German product pages: data-lang="de" (set by snippets/mcw-de-text.liquid)
        el.textContent = el.getAttribute('data-lang') === 'de'
          ? 'noch ' + d + ' T ' + pad(h) + ' Std ' + pad(m) + ' Min ' + pad(s % 60) + ' Sek'
          : d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s % 60) + 's left';
        el.hidden = false;
      });
    };
    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    const modal = document.getElementById('mcw-qv');
    if (!modal || modal.dataset.initialized || typeof modal.showModal !== 'function') return;
    modal.dataset.initialized = 'true';
    const title = modal.querySelector('#mcw-qv-title');
    const status = modal.querySelector('#mcw-qv-status');
    const image = modal.querySelector('#mcw-qv-img');
    const price = modal.querySelector('#mcw-qv-price');
    const description = modal.querySelector('#mcw-qv-desc');
    const details = modal.querySelector('#mcw-qv-details');
    const select = modal.querySelector('#mcw-qv-variant');
    const options = modal.querySelector('#mcw-qv-options');
    const digital = modal.querySelector('#mcw-qv-digital');
    const add = modal.querySelector('#mcw-qv-add');
    let controller;
    let trigger;
    let variants = [];
    let formatter;
    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: modal.dataset.currency, currencyDisplay: 'symbol' });
    } catch { return; }
    const format = cents => formatter.format(Number(cents) / 100);
    function updateVariant() {
      const variant = variants.find(item => String(item.id) === select.value);
      add.disabled = !variant?.available;
      add.textContent = variant?.available ? modal.dataset.add : modal.dataset.soldOut;
      digital.hidden = !variant || variant.requires_shipping !== false;
      price.replaceChildren();
      if (!variant) return;
      price.append(document.createTextNode(format(variant.price)));
      if (Number(variant.compare_at_price) > Number(variant.price)) {
        const compare = document.createElement('s');
        compare.textContent = format(variant.compare_at_price);
        price.append(compare);
      }
    }
    async function open(link) {
      controller?.abort();
      controller = new AbortController();
      const current = controller;
      const timeout = setTimeout(() => current.abort(), 12000);
      trigger = link;
      variants = [];
      select.replaceChildren();
      options.hidden = true;
      add.disabled = true;
      image.hidden = true;
      image.removeAttribute('src');
      digital.hidden = true;
      title.textContent = link.getAttribute('aria-label') || link.textContent;
      status.textContent = modal.dataset.loading;
      description.textContent = '';
      price.replaceChildren();
      details.href = link.href;
      if (!modal.open) modal.showModal();
      try {
        const root = modal.dataset.root.replace(/\/$/, '');
        const response = await fetch(root + '/products/' + encodeURIComponent(link.dataset.handle) + '.js', { signal: current.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Product unavailable');
        const product = await response.json();
        if (controller !== current || !modal.open) return;
        variants = Array.isArray(product.variants) ? product.variants : [];
        title.textContent = product.title;
        status.textContent = '';
        description.textContent = new DOMParser().parseFromString(product.description || '', 'text/html').body.textContent.trim();
        const source = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src;
        if (source) {
          const url = new URL(source, location.origin);
          if (url.protocol === 'https:') {
            url.searchParams.set('width', '800');
            image.src = url.href;
            image.alt = product.title;
            image.hidden = false;
          }
        }
        for (const variant of variants) {
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title + (variant.available ? '' : ' — ' + modal.dataset.soldOut);
          option.disabled = !variant.available;
          select.append(option);
        }
        const available = variants.find(variant => variant.available) || variants[0];
        if (available) select.value = String(available.id);
        options.hidden = variants.length < 2;
        updateVariant();
      } catch {
        if (controller === current && modal.open) status.textContent = modal.dataset.error;
      } finally { clearTimeout(timeout); }
    }
    document.addEventListener('click', event => {
      const link = event.target.closest?.('.mcw-qv-btn[data-handle]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      open(link);
    });
    modal.querySelector('[data-qv-close]').addEventListener('click', () => modal.close());
    modal.addEventListener('click', event => { if (event.target === modal) modal.close(); });
    modal.addEventListener('close', () => { controller?.abort(); trigger?.focus(); });
    select.addEventListener('change', updateVariant);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
